import { render, staticRenderFns } from "./ACT.vue?vue&type=template&id=86c03f36&scoped=true&lang=pug&"
import script from "./ACT.vue?vue&type=script&lang=js&"
export * from "./ACT.vue?vue&type=script&lang=js&"
import style0 from "./ACT.vue?vue&type=style&index=0&id=86c03f36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c03f36",
  null
  
)

export default component.exports